import { render, staticRenderFns } from "./contact-me.vue?vue&type=template&id=4922d510&scoped=true&"
import script from "./contact-me.vue?vue&type=script&lang=js&"
export * from "./contact-me.vue?vue&type=script&lang=js&"
import style0 from "./contact-me.vue?vue&type=style&index=0&id=4922d510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922d510",
  null
  
)

export default component.exports